import queryString from "query-string";
import { PLATFORMS } from "shared/payment/constants";

export default function getPaypalCallbacks({
	productId,
	discountId,
	origin,
	pathname,
	search,
	product,
	platform,
}) {
	// an empty product means the user's trying to save their paypal details
	const { productid, productSubtype } = product || {};

	let base;

	// on desktop, basically return the current page
	if (platform === PLATFORMS.DESKTOP) {
		base = (origin || "https://www.okcupid.com") + pathname;
	} else {
		base = `${origin || "https://www.okcupid.com"}/payments`;
	}

	let qs = queryString.parse(search || "");

	qs = {
		...qs,
		productid: productid || productId,
		platform,
	};

	// only add in type if there is a subtype
	// not the case if a user's just trying to save their paypal info
	if (productSubtype) {
		qs.type = productSubtype;
	}

	if (discountId) {
		qs.discountid = discountId;
	}

	return `${base}?${queryString.stringify(qs)}`;
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getPaypalCallbacks.js